import React from 'react'
import PropTypes from 'prop-types'

import MultilineEllipsisText from '@/checkout-instore-legacy/components/Commons/MultilineEllipsisText'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

const SidebarVendorName = (props) => {
  const maxCharactersPerLine = props.mediaQuery({
    desktop: 20,
    tablet: 18,
    phone: 12,
  })
  return (
    <MultilineEllipsisText
      {...props}
      maxCharactersPerLine={maxCharactersPerLine}
    />
  )
}

SidebarVendorName.propTypes = {
  name: PropTypes.string.isRequired,
  maxNumberOfLines: PropTypes.number,
  mediaQuery: PropTypes.func,
}
SidebarVendorName.defaultProps = {
  maxNumberOfLines: 2,
}

export default withMediaQuery(SidebarVendorName)
